/**
 * @generated SignedSource<<edd2d889f15c331ccb875f58c8834595>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type header_softwareReleasesVersionDetail$data = {
  readonly allIssues: {
    readonly totalCount: number;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesVersionDetail_AsyncEditableName" | "connectApps_softwareReleasesVersionDetail" | "releaseNotesButton_softwareReleasesVersionDetail" | "ui_softwareReleasesManageWarnings_ManageWarningsModal">;
  readonly " $fragmentType": "header_softwareReleasesVersionDetail";
};
export type header_softwareReleasesVersionDetail$key = {
  readonly " $data"?: header_softwareReleasesVersionDetail$data;
  readonly " $fragmentSpreads": FragmentRefs<"header_softwareReleasesVersionDetail">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "header_softwareReleasesVersionDetail",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "allIssues",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "totalCount"
            },
            "action": "THROW",
            "path": "allIssues.totalCount"
          }
        ],
        "storageKey": "issues(filter:\"ALL\")"
      },
      "action": "THROW",
      "path": "allIssues"
    },
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesVersionDetail_AsyncEditableName"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal"
    },
    {
      "kind": "FragmentSpread",
      "name": "connectApps_softwareReleasesVersionDetail"
    },
    {
      "kind": "FragmentSpread",
      "name": "releaseNotesButton_softwareReleasesVersionDetail"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "f18c07820c274d0155b6bcd5afb8be06";

export default node;
